export enum MolIconButtonTypeEnum {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}
